import { useMutation } from '@tanstack/react-query';
import axiosInstance from '../../axiosConfig';

const resolveMediaPath = async (path) => {
  const response = await axiosInstance.get('/media_library/resolve/', {
    params: { path },
  });
  return response.data;
};

export const useResolveMediaPath = () => {
  const mutation = useMutation({ mutationFn: resolveMediaPath });

  return {
    resolveMediaPath: mutation.mutateAsync,
    isLoading: mutation.isPending,
  };
};
